import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Database } from '../../Master/database/database';
import { requeststatus } from './requeststatus';

let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');

@Injectable({
  providedIn: 'root'
})

export class RequestdashboardService {



  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  getDatabase(): Observable<Database[]> {
    return this.httpClient.get<Database[]>(this.baseUrl + 'api/DatabaseApi')
  }
  getActivedatabase(): Observable<Database[]> {
    return this.httpClient.get<Database[]>(this.baseUrl + 'api/DatabaseApi/getactivedatabases')
  }
  GetAll(): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/RequestDashboardApi/GetAll')
  }

  Post(status: requeststatus): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/RequestDashboardApi/AddStatus', status, { headers: header, observe: 'response' })
  }
  //getRequestDashboardExportToExcel(): Observable<any> {
  //  return this.httpClient.get<any>(this.baseUrl + 'api/RequestDashboardApi/RequestDashboardExportToExcel');
  //};

  getRequestDashboardExportToExcel(data: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/RequestDashboardApi/RequestDashboardExportToExcel', data, { headers: header, observe: 'response' });
  };

  getRequestDashboardCount(data:any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/RequestDashboardApi/getRequestDashboardCount', data, { headers: header, observe: 'response' })
  }

  getRequestDashboardDetails(data: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/RequestDashboardApi/getRequestDashboardDetails', data, { headers: header, observe: 'response' })
  }
}
